import * as React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Confirm component
 *
 * React component responsible for handling status messages for email confirmation.
 *
 * @class Confirm
 * @extends {React.SFC<any>}
 */
const Confirm: React.SFC<any> = (props) => {
	let message: string | null = 'An error occurred while confirming your email address.';
	let loginMessage: string | null = null;

	if (props.location && props.location.search) {
		const searchParams = new URLSearchParams(props.location.search);
		if (searchParams.has('message')) {
			message = searchParams.get('message');
		}
		if (searchParams.has('loginMessage')) {
			loginMessage = searchParams.get('loginMessage');
		}
	}

	return (
		<div>
			<h2 className="login-form-heading">{message}</h2>
			{loginMessage ? (
				<p className="login-form-heading">
					<NavLink to="/login" exact className="text-bold" activeClassName="active">
						{loginMessage}
					</NavLink>
				</p>
			) : null}
		</div>
	);
};

export default Confirm;
